import { createOutlineIcon } from "../createIcon";

export const ChevronDownOutlineIcon = createOutlineIcon(
  <path d="m7 10 5 4.58L17 10" />,
  "ChevronDownOutlineIcon"
);
